import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import "./fill-pdf.css";
import { message, Modal } from "antd";
import { useClaimContext } from "../claim-context";
import { fillPdf } from "../../../../../exports/preview-form-pdf";

// Setup the PDF.js worker — react-pdf v9 uses pdfjs-dist v4 which ships a .mjs worker.
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

const FillPdfFromAssets = () => {
  const { claimForm, pdfFormData } = useClaimContext();
  const [visible, setVisible] = useState(false);
  const [filledPdfUrl, setFilledPdfUrl] = useState(null);

  useEffect(() => {
    const loadData = async (pdfFormData) => {
      try {
        const pdfUrl = await fillPdf(pdfFormData);
        setFilledPdfUrl(pdfUrl);
      } catch (err) {
        message.error("Error loading data:", err);
      }
    };

    loadData(pdfFormData);

    return () => {
      if (filledPdfUrl) URL.revokeObjectURL(filledPdfUrl);
    };
  }, [pdfFormData, claimForm]);

  if (!filledPdfUrl) return <div>Loading PDF...</div>;

  return (
    <div className="custom-pdf-preview">
      <div onClick={() => setVisible(true)}>
        <Document file={{ url: filledPdfUrl }}>
          <Page width={300} pageNumber={1} />
        </Document>
      </div>
      <Modal
        title="PDF Preview"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        width={800}
        style={{ top: 20 }}
        className="pdf-modal"
      >
        {filledPdfUrl ? (
          <Document file={filledPdfUrl}>
            <Page pageNumber={1} width={760} />
          </Document>
        ) : (
          <div style={{ padding: 24 }}>Loading PDF...</div>
        )}
      </Modal>
    </div>
  );
};

export default FillPdfFromAssets;
